import React, { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useQuery } from "react-query";
import { getClientList } from "../Apis/apis";

import AllStateContext from "../../context/allstateContext";

export const Navbar = ({
  title,
  home,
  analysis,
  budgets,
  account,
  categories,
  contact,
}) => {
  const { setOpen, setRecordItem, searchDetail, setSearchDetail } =
    useContext(AllStateContext);
  const [selected, setSelected] = useState("Home");
  const [hideMobileMenu, setHideMobileMenu] = useState(false);

  const [theme, setTheme] = useState(() => {
    return localStorage.getItem("theme") || "dark";
  });

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem("theme", theme);
  }, [theme]);

  const { data: clients } = useQuery("clientList", async () => {
    try {
      const response = await getClientList();
      return response.data?.payload?.data || [];
    } catch (e) {
      return [];
    }
  });

  const [selectedClientId, setSelectedClientId] = useState(() => localStorage.getItem("selectedClientId") || "");

  const handleClientChange = (e) => {
    const clientId = e.target.value;
    if (clientId) {
      localStorage.setItem("selectedClientId", clientId);
    } else {
      localStorage.removeItem("selectedClientId");
    }
    setSelectedClientId(clientId);
    window.location.reload();
  };

  const toggleTheme = () => {
    setTheme((prev) => (prev === "dark" ? "light" : "dark"));
  };
  const handelAmountNotes = (e) => {
    const { name, value } = e.target;
    setSearchDetail((data) => {
      return { ...data, [name]: value };
    });
  };
  const changeTitle = (title_name) => {
    setSelected(title_name);
    setHideMobileMenu(false);
    document.title = title_name;
    if (title_name === "Home") {
      setSearchDetail({ balance: "", name: "" });
    }
  };
  const history = useNavigate();
  const logoutHandel = () => {
    localStorage.removeItem("token");

    history("/Login");
  };
  return (
    <nav 
      className="navbar navbar-expand-lg fixed-top"
      style={{
        background: "var(--nav-bg)",
        backdropFilter: "blur(16px)",
        WebkitBackdropFilter: "blur(16px)",
        borderBottom: "1px solid var(--nav-border)",
        boxShadow: "0 4px 30px var(--nav-shadow)",
        padding: "12px 24px",
        zIndex: 1030
      }}
    >
      <div className="container-fluid px-4 d-flex align-items-center">
        <Link
          className="navbar-brand d-flex align-items-center"
          to="/home"
          onClick={() => changeTitle("Home")}
          style={{
            fontWeight: "800",
            fontSize: "1.4rem",
            background: "linear-gradient(135deg, var(--primary) 0%, var(--success) 100%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            letterSpacing: "-0.02em",
            marginRight: "24px"
          }}
        >
          My Money
        </Link>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
          onClick={() => setHideMobileMenu(!hideMobileMenu)}
          style={{
            border: "1px solid var(--border-color)",
            padding: "4px 8px"
          }}
        >
          <span className="navbar-toggler-icon" style={{ filter: "invert(1)" }}></span>
        </button>
        <div
          className={`collapse navbar-collapse ${hideMobileMenu ? "show" : ""}`}
          id="navbarSupportedContent"
        >
          <ul className="navbar-nav me-auto mb-2 mb-lg-0 gap-1">
            {[
              { label: home,       path: "/home",       name: "Home" },
              { label: "Record",   path: "/record",     name: "Record" },
              { label: analysis,   path: "/analysis",   name: "Analysis" },
              { label: budgets,    path: "/budgets",    name: "Budgets" },
              { label: account,    path: "/account",    name: "Accounts" },
              { label: categories, path: "/categories", name: "Categories" },
              { label: contact,    path: "/contact",    name: "Contact" },
              { label: "Profile",  path: "/profile",    name: "Profile" },
            ].map((item) => (
              <li className="nav-item" key={item.name}>
                <Link
                  className="nav-link"
                  to={item.path}
                  onClick={() => changeTitle(item.name)}
                  style={{
                    color: selected === item.name ? "var(--text-primary)" : "var(--text-secondary)",
                    backgroundColor: selected === item.name ? "var(--bg-surface-hover)" : "transparent",
                    padding: "8px 16px",
                    borderRadius: "10px",
                    fontWeight: "500",
                    fontSize: "0.95rem",
                    transition: "all var(--transition-fast)",
                    border: selected === item.name ? "1px solid var(--border-color)" : "1px solid transparent"
                  }}
                  onMouseEnter={(e) => {
                    if (selected !== item.name) {
                      e.target.style.color = "var(--primary)";
                      e.target.style.backgroundColor = "var(--bg-surface-hover)";
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (selected !== item.name) {
                      e.target.style.color = "var(--text-secondary)";
                      e.target.style.backgroundColor = "transparent";
                    }
                  }}
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>

          <div className="d-flex align-items-center gap-3 ms-auto navbar-actions">
            <div className="position-relative">
              <input
                name="name"
                className="form-control"
                type="search"
                placeholder="Search notes..."
                aria-label="Search"
                onChange={handelAmountNotes}
                value={searchDetail.name}
                style={{
                  width: "200px",
                  fontSize: "0.88rem",
                  padding: "8px 14px !important",
                  height: "38px"
                }}
              />
            </div>

            {/* Client Selector (Only visible if the user is a CA for clients) */}
            {clients && clients.length > 0 && (
              <select
                className="form-select"
                value={selectedClientId}
                onChange={handleClientChange}
                style={{
                  width: "auto",
                  height: "38px",
                  fontSize: "0.85rem",
                  fontWeight: "600",
                  backgroundColor: "rgba(16, 185, 129, 0.1)",
                  color: "#10b981",
                  border: "1px solid rgba(16, 185, 129, 0.3)",
                  borderRadius: "8px",
                  cursor: "pointer"
                }}
              >
                <option value="">My Own Account</option>
                {clients.map(client => (
                  <option key={client.userId} value={client.userId}>
                    Viewing: {client.name}
                  </option>
                ))}
              </select>
            )}

            {/* Theme Toggle Button */}
            <button
              className="btn btn-secondary d-flex align-items-center justify-content-center"
              type="button"
              onClick={toggleTheme}
              style={{
                width: "38px",
                height: "38px",
                borderRadius: "50%",
                padding: "0",
                minWidth: "38px",
                background: "var(--bg-surface)",
                borderColor: "var(--border-color)",
                color: "var(--text-primary)",
                fontSize: "1.2rem",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                transition: "all var(--transition-fast)"
              }}
            >
              {theme === "dark" ? "☀️" : "🌙"}
            </button>

            <button
              className="btn btn-primary d-flex align-items-center justify-content-center"
              type="button"
              onClick={() => {
                setOpen(true);
                setRecordItem("");
              }}
              style={{
                width: "38px",
                height: "38px",
                borderRadius: "50%",
                padding: "0",
                minWidth: "38px",
                background: "linear-gradient(135deg, var(--primary) 0%, #7c3aed 100%)",
                boxShadow: "0 0 12px rgba(99, 102, 241, 0.4)",
                transition: "all var(--transition-fast)"
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "rotate(90deg) scale(1.1)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "rotate(0deg) scale(1)";
              }}
            >
              <img
                style={{ height: "18px", width: "18px", filter: "invert(1)" }}
                src={require("../../Common/Icon/plus.png")}
                alt="add-record"
              />
            </button>

            <button
              className="btn btn-outline-danger"
              type="button"
              onClick={logoutHandel}
              style={{
                padding: "8px 16px",
                fontSize: "0.88rem",
                fontWeight: "500",
                height: "38px"
              }}
            >
              Logout
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
};
